<template>
  <section class="gallery-details-wrap ptb-100">
    <div class="container">
      <div class="row gx-5">
        <div class="col-xl-8">
          <div class="gallery-desc">
            <img
              class="gallery-img mb-25"
              src="../../assets/images/gallery/single-gallery-1.jpg"
              alt="Image"
            />

            <h2>Health Care For Your Family And Our Doctor For You</h2>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Mollitia
              excepturi eaque, corporis nulla maxime inventore magni
              reprehenderit consequatur deserunt, eligendi totam voluptas natus.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing, elit. Quasi,
              porro expedita dolores quas nesciunt repellat sed. Nostrum sunt
              obcaecati totam distinctio libero ea aliquam hic a consectetur, et
              facere rem repudiandae maxime dolorem ad, saepe harum blanditiis
              laborum.
            </p>
            <h3>Project Summary</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Voluptates odio omnis dolor numquam dignissimos consectetur amet
              sit lorem ipsum dolor, sit amet consectetur adipisicing elit.
            </p>

            <ul class="content-feature-list style5 list-style">
              <li>
                <i class="ri-check-double-line"></i>Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed diam nonumy eirmod tempor.
              </li>
              <li>
                <i class="ri-check-double-line"></i>Advisory membership elitr,
                sed diam nonumy eirmod tempor invidunt ut labor et dolore magna.
              </li>
              <li>
                <i class="ri-check-double-line"></i>If you do not have enough
                time, you will always be able to work and do what you want.
              </li>
              <li>
                <i class="ri-check-double-line"></i>Irmad temporarily involved
                labor and doll magna alicum erat, sed diam voluptua. Vero Eos
                and accused and fair.
              </li>
              <li>
                <i class="ri-check-double-line"></i>Labor and Love Magna Aliquam
                Irat, Sed Diam Valupatua. Vero eos et accusam et justo dolores
                et ea ribam.
              </li>
            </ul>
            <blockquote class="wp-block-quote">
              <div class="wp-quote-text">
                <p>
                  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed
                  cum fuga ab, eum numquam ea dolores quae takimata sanctus est
                  Lorem amet ducimus Lorem ipsum, dolor sit amet consectetur
                  adipisicing amet"
                </p>
                <h5>Rosalline Kelan</h5>
              </div>
            </blockquote>
            <h2>Our Treatment Plans</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Voluptates odio omnis dolor numquam dignissimos enim assumenda
              itaque nemo tenetur dolores incidunt, animi quo quae odit
              corporis, nihil architecto inventore.
            </p>

            <div class="row align-items-center mt-30">
              <div class="col-md-6 mb-25">
                <img
                  class="gallery-img"
                  src="../../assets/images/gallery/gallery-2.jpg"
                  alt="Image"
                />
              </div>

              <div class="col-md-6 mb-25">
                <img
                  class="gallery-img"
                  src="../../assets/images/gallery/gallery-3.jpg"
                  alt="Image"
                />
              </div>
            </div>
            <p>
              Epsum dolor sit amet consectetur adipisicing elit. Vitae, non.
              Nulla optio voluptate delectus minus numquam cumque labore,
              perferendis necessitatibus et, error eos commodi quae eveniet quia
              vitae enim nam!
            </p>
          </div>

          <div class="post-navigation mt-20 mb-0">
            <router-link to="/gallery-details" class="prev-post">
              PREV PORTFOLIO
              <span>Research Facility...</span>
            </router-link>
            <router-link to="/gallery-details" class="next-post">
              NEXT PORTFOLIO
              <span>Optimizing Horomone...</span>
            </router-link>
          </div>
        </div>

        <div class="col-xl-4">
          <SideBar />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SideBar from "./SideBar.vue";

export default {
  name: "PortfolioDetails",
  components: {
    SideBar,
  },
};
</script>